import Tabs from '@/components/Tabs/Tabs';
import styles from './GenerateModel.module.less';
import { useEffect, useRef, useState } from 'react';
import uploadIcon from '@/assets/home/chooseimg.png';
import loadingIcon from '@/assets/loading.gif';

import { Input, Upload } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { SDService, projectController } from '@/api';
import UploadProgress from '@/components/UploadProgress/UploadProgress';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import Uploader from '@/utils/uppyUpload';
import toast from 'react-hot-toast';
import { base64ToFile, fileExtension, isFormatFile } from '@/utils/file';
import ConfirmDialog from '@/components/ConfirmDialog/ConfirmDialog.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setShowPricePage } from '@/store/slices/home.js';
import jsFunc from '@/utils/jsFunc';
import message, { info } from '@/utils/message';
import { reportData } from '@/utils/trackingPoint';
import { getImageSize } from '@/utils/image';
export default function Home(props) {
  const [tab, setTab] = useState(0);
  const [imageFileInfo, setImageFileInfo] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [meshFile, setMeshFile] = useState(null);
  const [inputText, setInputText] = useState(null);
  const [promptList, setPromptList] = useState([]);

  const [showBanlanceModal, setShowBanlanceModal] = useState(false);
  const dispatch = useDispatch();

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [creating, setCreating] = useState(false);

  const [uploadLoading, setUploadLoading] = useState(false);
  const glbViewerRef = useRef(null);
  const imageUploadResult = useRef(null);
  const preProjectId = useRef(null);

  const testTaskId = false; // 走测试id
  const uploader = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const name = query.get('register');
    if (!window.reportDataGoogle) {
      if (name === 'true') {
        reportData('signup-google-success');
      } else if (name === 'false') {
        reportData('login-google-success');
      }
      window.reportDataGoogle = true;
    }
  }, []);

  useEffect(() => {
    query();
    return () => {
      console.log('组件销毁');
      if (uploader.current != null) {
        uploader.current.stop();
        uploader.current = null;
      }
    };
  }, []);
  const query = async () => {
    const res = await projectController.textList({});
    if (res.code == 0) {
      setPromptList(res.data);
    }
  };

  const uploadFile = (file, type) => {
    const fileExtension = file.name.split('.').pop();
    return new Promise((reslove, reject) => {
      uploader.current = new Uploader(type, { ext: fileExtension });
      uploader.current.onComplete = async (result) => {
        reslove(result);
      };
      uploader.current.uploadFileWithSlice(file);
    });
  };

  const uploadImage = async (imageFileInfo) => {
    reportData('home-start-model');

    if (uploading) {
      info('Waiting for generation to complete');
      return;
    }
    setImageFileInfo(imageFileInfo);
    setImageURL(URL.createObjectURL(imageFileInfo.file));
    try {
      setUploading(true);
      imageUploadResult.current = await uploadFile(imageFileInfo.file, 1);
      if (uploader.current) {
        preCreate(imageFileInfo);
      }
    } catch (error) {
      message.error('System error', {
        id: 'only',
      });
      console.error(error);
      setUploading(false);
    }
  };

  // 预创建项目
  const preCreate = async (imageFileInfo) => {
    try {
      const params = {
        name: imageFileInfo ? imageFileInfo.file.name : null,
        type: 1, // ProjectTypeEnum
        mode: 'model_3d', // ConsumptionMode
        tempId: '',
      };
      let type = 0;
      if (imageFileInfo) {
        const fileExtension = imageFileInfo.file.name.split('.').pop().toLowerCase();

        if (fileExtension === 'png') {
          type = 3;
        } else if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
          type = 4;
        }
        params['coverStream'] = {
          type: type, // streamType 0 OBJ 1 FBX 2 GLB 3 PNG 4 JPEG
          upload: {
            uploadId: imageUploadResult.current ? imageUploadResult.current.uploadId : null,
            completedParts: imageUploadResult.current ? imageUploadResult.current.eTags : null,
          },
        };
      } else {
        params['prompt'] = inputText;
      }

      const startTime = new Date().getTime();

      const res = await projectController.createPreProject({
        body: params,
      });
      console.log('本次创建项目总耗时(ms)', new Date().getTime() - startTime);
      if (res.code === 0) {
        // 创建成功
        const projectId = res.data;
        preProjectId.current = projectId;
      } else {
        message.error('System error', {
          id: 'only',
        });
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const startButtonEnable = () => {
    if (!uploading && (inputText || imageUploadResult.current)) {
      return true;
    }
    return false;
  };

  const create = async () => {
    reportData('home-start-model');
    if (!startButtonEnable() || creating) {
      return;
    }

    const startTime = new Date().getTime();
    setCreating(true);
    try {
      let type = 0;
      if (imageFileInfo) {
        const fileExtension = imageFileInfo.file.name.split('.').pop().toLowerCase();

        if (fileExtension === 'png') {
          type = 3;
        } else if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
          type = 4;
        }
      } else {
        // 只是文字
        await preCreate(imageFileInfo);
      }

      const res = await projectController.create({
        body: {
          name: imageFileInfo ? imageFileInfo.file.name : null,
          type: 1, // ProjectTypeEnum
          mode: 'model_3d', // ConsumptionMode
          tempId: '',
          projectId: preProjectId.current,
          coverStream: {
            type: type, // streamType 0 OBJ 1 FBX 2 GLB 3 PNG 4 JPEG
            upload: {
              uploadId: imageUploadResult.current ? imageUploadResult.current.uploadId : null,
              completedParts: imageUploadResult.current ? imageUploadResult.current.eTags : null,
            },
          },
        },
      });
      console.log('本次创建项目总耗时(ms)', new Date().getTime() - startTime);
      if (res.code === 0) {
        // 创建成功
        const { projectId, cover } = res.data;
        const res3d = await SDService.submit_3d({
          imageUrl: cover,
          projectId: projectId,
          text: inputText,
          platformType: '1', // 0 是混元 1 是tripo
        });
        if (res3d.code === 0) {
          navigate('/preview/' + projectId);
        } else {
          message.error(res3d.msg || 'System error', {
            id: 'only',
          });
        }
      } else if (res.code === -111) {
        // message.error('Insufficient balance, please recharge.', {
        //   id: 'only',
        // });
        setShowBanlanceModal(true);
        setCreating(false);
      } else if (res.code === -34) {
        message.error('System error', {
          id: 'only',
        });
        setCreating(false);
      } else {
        message.error('System error', {
          id: 'only',
        });
        setCreating(false);
      }
    } catch (error) {
      console.error(error);
      setCreating(false);
    }
  };

  // 截图 -> base64
  const snapshotBase64 = (mime = 'image/png', quality) => {
    // 需要在 renderer 初始化时设置 preserveDrawingBuffer:true 才能截图
    const dataURL = document.getElementById('glbViewer').toDataURL(mime, quality); // 'data:image/png;base64,...'
    // 如果你只要纯 base64（无前缀）：
    const base64 = dataURL.split(',')[1];
    return { dataURL, base64 };
  };

  return (
    <div className={styles['container']}>
      <div className={styles['caption']}>Generate 3D model</div>

      <Upload
        beforeUpload={() => false}
        showUploadList={false}
        accept=".jpg,.png,.jpeg"
        onChange={async (info) => {
          reportData('upload-image');
          const isLt2M = info.file.size / 1024 / 1024 < 10;
          if (!isLt2M) {
            message.info('Please upload a file smaller than 10MB');
            return;
          }
          if (isFormatFile(info.file, ['.jpg', '.png', '.jpeg'])) {
            const size = await getImageSize(info.file);
            console.log('size', size);
            if (size.width > 6000 || size.width < 20 || size.height > 6000 || size.height < 20) {
              message.info('The width and height of the image must be within 20–6000.');
              return;
            }
            uploadImage(info);
            reportData('upload-image-success');
          } else {
            message.info('Invalid format');
          }
        }}>
        <div className={styles['input-wrapper']}>
          <div className={styles['texure-tab-content']}>
            {!imageFileInfo ? (
              <>
                <img className={styles['icon']} src={uploadIcon}></img>
              </>
            ) : (
              <>
                <img className={styles['upload-image']} src={imageURL}></img>
                {uploading ? (
                  <div className={styles['loading']}>
                    <img src={loadingIcon}></img>
                  </div>
                ) : (
                  <></>
                )}
                <div className={styles['upload-icon']}>
                  <img src={uploadIcon}></img>
                </div>
              </>
            )}
          </div>
          <Input
            variant="filled"
            className={styles['input']}
            value={inputText}
            onClick={(event) => {
              event.stopPropagation();
            }}
            placeholder="Describe the object and the texture style..."
            onChange={(event) => {
              setInputText(event.target.value);
            }}></Input>
        </div>
      </Upload>
      <div className={styles['prompts-title']}>缺少灵感?试试这些提示词:</div>
      <div className={styles['prompt-list']}>
        {promptList.map((prompt) => {
          return (
            <div
              key={prompt}
              className={styles.prompt}
              onClick={() => {
                setInputText(prompt);
              }}>
              {prompt}
            </div>
          );
        })}
      </div>

      <div
        className={`${styles['start-btn']}  ${startButtonEnable() ? styles['enable'] : null}`}
        onClick={create}>
        {creating ? 'Creating...' : 'Get started'}
      </div>

      {showBanlanceModal && (
        <ConfirmDialog
          confirmTitle="Confirm to recharge"
          content="Insufficient balance, please recharge."
          onConfirm={() => {
            dispatch(setShowPricePage(true));
            setShowBanlanceModal(false);
            props?.onCancel();
          }}
          onCancel={() => {
            setShowBanlanceModal(false);
          }}></ConfirmDialog>
      )}
    </div>
  );
}
